import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { Controller, useForm } from "react-hook-form";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { useDispatch } from "react-redux";
import { Error } from "../../../common/Error";
import { withdrawApplication } from "../../../../redux/actions";

type WithdrawButtonAndDialogProps = {
  orgId: string;
  id: string;
  disabled: boolean;
};

export const WithdrawButtonAndDialog: React.FC<WithdrawButtonAndDialogProps> = ({
  orgId,
  id,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton
        text="Withdraw"
        tooltip="Withdraw application"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      />
      {isOpen && (
        <WithdrawDialog
          orgId={orgId}
          id={id}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

type WithdrawDialogProps = {
  orgId: string;
  id: string;
  onClose: () => void;
};

const WithdrawDialog: React.FC<WithdrawDialogProps> = ({
  orgId,
  id,
  onClose,
}) => {
  const dispatch = useDispatch();

  const { control, errors, handleSubmit } = useForm({
    defaultValues: { note: "" },
  });

  const onSubmit = (data: { note: string }) => {
    dispatch(withdrawApplication(orgId, id, data.note));
    onClose();
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        data-test="withdraw-dialog"
      >
        <DialogTitle data-test="withdraw-dialog-title">
          Withdraw application
        </DialogTitle>

        <DialogContent>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="note"
                  control={control}
                  rules={{ required: true }}
                  as={
                    <TextField
                      label="Message"
                      multiline
                      fullWidth
                      rows={5}
                      data-test="withdraw-message"
                      required
                    />
                  }
                />
                {errors.note && errors.note.type === "required" && (
                  <Error>This field is required</Error>
                )}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" data-test="withdraw-close">
            Close
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            color="primary"
            data-test="withdraw-confirm"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
